module.exports = __webpack_public_path__ + "img/CCAMX45.7e0c7ac8.png";